package lacaravana.ui

import kotlinx.browser.document
import kotlinx.coroutines.launch
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import kotlinx.html.js.onSubmitFunction
import lacaravana.app.Database
import lacaravana.app.appScope
import lacaravana.domain.Menu
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLSelectElement

object MenuAdminView {
    suspend fun render(db: Database) {
        val content = document.getElementById("content") ?: return
        content.innerHTML = ""
        val items = Menu.all(db)

        content.append {
            h2 { +"Menu" }
            form {
                classes = setOf("form-row")
                id = "add-item-form"
                input(type = InputType.text) { id = "item-nombre"; placeholder = "Nombre"; required = true }
                select {
                    id = "item-categoria"
                    option { value = "entrante"; +"Entrante" }
                    option { value = "principal"; +"Principal" }
                    option { value = "postre"; +"Postre" }
                    option { value = "bebida"; +"Bebida" }
                }
                input(type = InputType.number) { id = "item-precio"; placeholder = "Precio (cents)"; required = true }
                button(type = ButtonType.submit) { +"Añadir" }
                onSubmitFunction = { e ->
                    e.preventDefault()
                    val nombre = (document.getElementById("item-nombre") as HTMLInputElement).value
                    val categoria = (document.getElementById("item-categoria") as HTMLSelectElement).value
                    val precio = (document.getElementById("item-precio") as HTMLInputElement).value.toIntOrNull() ?: 0
                    if (nombre.isNotBlank() && precio > 0) {
                        appScope.launch {
                            Menu.add(db, nombre, categoria, precio)
                            render(db)
                        }
                    }
                }
            }
            table {
                thead { tr { th { +"Nombre" }; th { +"Categoría" }; th { +"Precio" }; th { +"Estado" }; th { } } }
                tbody {
                    for (item in items) {
                        tr {
                            attributes["data-item"] = item.nombre
                            td { +item.nombre }
                            td { +item.categoria }
                            td { +Menu.formatPrice(item.precioCents) }
                            td {
                                span("badge ${if (item.disponible) "badge-listo" else "badge-pendiente"}") {
                                    +(if (item.disponible) "disponible" else "no disponible")
                                }
                            }
                            td {
                                button {
                                    attributes["data-action"] = "toggle"
                                    +(if (item.disponible) "Desactivar" else "Activar")
                                    onClickFunction = {
                                        appScope.launch { Menu.toggleDisponible(db, item.id); render(db) }
                                    }
                                }
                                button(classes = "danger") {
                                    attributes["data-action"] = "delete"
                                    +"Borrar"
                                    onClickFunction = {
                                        appScope.launch { Menu.delete(db, item.id); render(db) }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
